/*
Contoh meng-override reveal animation:

window.revealAnimationConfig = {
  effects: {
    // Override a core effect property without touching the others
    'slide-up': { autoAlpha: 0, y: 120, duration: 1.5, ease: 'power4.out' }, // Replaced the baseline 50px offset and 0.8s duration
    
    // Add a brand new effect completely unique to your child theme
    'pop-in': { scale: 0, autoAlpha: 0, duration: 0.8, ease: 'back.out(1.7)' }
  },
  rules: {
    // Prevent the parent theme from animating images (overrides value with false)
    'slide-up': false, 
    
    // Expand the mask-up defaults to also include your new popup elements
    'mask-up': 'h1, h2, h3, h4, h5, h6, .menu-panel',
    // Bind your newly created 'pop-in' effect to all buttons!
    'pop-in': '.button'
  }
};
*/

window.revealAnimationConfig = {
  rules: {
    'mask-up': 'h1, h2, h3, h4, h5, h6, p, li, .button, .share-icon'
  }
};

(function ($) {
  if (history.scrollRestoration) {
    history.scrollRestoration = 'manual';
  }
  window.scrollTo(0, 0);

  // window.addEventListener('beforeunload', function () {
  //   window.scrollTo(0, 0);
  // });

  $(document).ready(function () {
    const isDesktop = typeof Foundation !== "undefined" && Foundation.MediaQuery.atLeast("large");
    gsap.registerPlugin(ScrollTrigger);
    if (typeof ScrollTrigger.clearScrollMemory === 'function') {
      ScrollTrigger.clearScrollMemory("manual");
    }
    
    window.scrollTo(0, 0);

    // --- Smooth Scrolling Init ---
    if (typeof Lenis !== 'undefined') {
      const lenis = new Lenis({
        lerp: 0.1, // smoothing physics
        smoothWheel: true
      });

      // Synchronize Lenis' requestAnimationFrame loop with GSAP's native ticker
      // for mathematically perfect stagger-sync between scroll position and animations
      gsap.ticker.add((time) => {
        lenis.raf(time * 1000);
      });
      gsap.ticker.lagSmoothing(0);

      // Make lenis global for other scripts to use
      window.lenis = lenis;
    }
    // ----------------------------
    const $panel = $('header .menu-panel');
    const $menuContainer = $('header .menu-container');
    const $toggle = $('header .menu-toggle');
    const $closeBtn = $('header .menu-close');
    const projectChildren = 'header .menu-projects-container > div';
    const menuItems = 'header .menu-items-container .menu-item > a';
    const contactCells = 'header .menu-contact-container .cell > *';
    const separatorLines = 'header .menu-panel .separator-line';

    // Animation Config Variables
    const menuAnimationSpeed = 0.5;
    const menuAnimationStagger = 0.1;
    let menuSlideshow;

    // Initially hide the close button and menu contents
    // gsap.set($closeBtn, { autoAlpha: 0 });

    // Setup children initial states
    gsap.set('header .menu-projects-container', { autoAlpha: 0 });
    gsap.set([menuItems, contactCells], { y: '110%' }); // "Rise" from the very bottom of clipped wrapper
    gsap.set(separatorLines, { width: 0 });

    /**
     * Menu Projects Slideshow (Horizontal rotated loop)
     */
    function initMenuProjectSlideshow() {
      const $projectsContainer = $('.menu-projects-container');
      const $wrapper = $('.menu-slides-wrapper');
      const $slides = $('.menu-project-slide'); 
      const $nums = $('.menu-slide-number');
      const $numContainer = $('.menu-current-slide');
      if (!$slides.length) return null;

      // Dynamically wrap text elements for mask animations
      $projectsContainer.find('.featured-project-title, .project-type, .project-location').each(function() {
        const $el = $(this);
        if (!$el.find('.fp-mask-inner').length) {
          $el.wrapInner('<span class="fp-mask-outer" style="display: block; overflow: hidden;"><span class="fp-mask-inner" style="display: block;"></span></span>');
        }
      });

      const count = $slides.length;
      const wrapCount = count + 1;
      const pctPerSlide = 100 / wrapCount;
      const slideDur = 0.8; // how long it takes for slide to lock in
      const pauseDur = 0.1; // how long to wait after slide locks in to start in-slide animation

      // Force layout that respects container width for percentage moves
      gsap.set($wrapper, { display: 'flex', width: (wrapCount * 100) + '%', flexWrap: 'nowrap' });
      gsap.set($slides, { width: pctPerSlide + '%', flex: '0 0 ' + pctPerSlide + '%', position: 'relative' });

      // Ghost measurement to prevent jumping on hidden elements
      const $ghost = $nums.first().clone().css({
        position: 'fixed',
        visibility: 'hidden',
        left: '-10000px',
        whiteSpace: 'nowrap'
      }).appendTo('body');
      const h = $ghost.outerHeight() || 0;
      $ghost.remove();

      if (h) $numContainer.css('height', h + 'px');

      // Clone first for seamless wrap
      const $firstClone = $slides.first().clone().appendTo($wrapper).css({
         width: pctPerSlide + '%',
         flex: '0 0 ' + pctPerSlide + '%'
      });
      const $firstNumClone = $nums.first().clone().appendTo($numContainer).css('display', 'block');

      let currentIndex = 0;
      let timer;

      // Initial cleanup
      gsap.set('.menu-projects-container .fp-mask-inner', { yPercent: 100 });

      function goToSlide(index) {
        const isWrap = (index === count);
        const targetIdx = index;
        const tl = gsap.timeline({
          onComplete: () => {
            if (isWrap) {
              gsap.set($wrapper, { xPercent: 0 });
              gsap.set([$nums, $firstNumClone], { y: 0 });
              currentIndex = 0;
            } else {
              currentIndex = targetIdx;
            }
            timer = gsap.delayedCall(4, () => goToSlide(currentIndex + 1));
          }
        });

        // 1. Move Tapes
        tl.to($wrapper, { xPercent: -pctPerSlide * targetIdx, duration: slideDur, ease: 'power2.inOut' }, 0)
          .to([$nums, $firstNumClone], { y: -targetIdx * h, duration: slideDur, ease: 'power2.inOut' }, 0);
        
        // 2. Masks
        const $targetSlide = (isWrap) ? $firstClone : $slides.eq(targetIdx);
        const $infoMasks = $targetSlide.find('.project-type .fp-mask-inner, .project-location .fp-mask-inner');
        const $titleMask = $targetSlide.find('.featured-project-title .fp-mask-inner');
        
        // Start mask reveals dynamically after the slide animation finishes + the pause duration
        tl.fromTo($infoMasks, { yPercent: 100 }, { yPercent: 0, duration: 0.5, ease: 'power2.out' }, slideDur + pauseDur)
          .fromTo($titleMask, { yPercent: 100 }, { yPercent: 0, duration: 0.5, ease: 'power2.out' }, ">");
      }

      return {
        start: () => {
           // Reveal slide 0 first
           const $s0 = $slides.eq(0);
           const tl = gsap.timeline({ delay: 0.2 });
           tl.fromTo($s0.find('.project-type .fp-mask-inner, .project-location .fp-mask-inner'), { yPercent: 100 }, { yPercent: 0, duration: 0.5, ease: 'power2.out' })
             .fromTo($s0.find('.featured-project-title .fp-mask-inner'), { yPercent: 100 }, { yPercent: 0, duration: 0.6, ease: 'power2.out' }, ">0.1");
           
           timer = gsap.delayedCall(4, () => goToSlide(1));
        },
        stop: () => { if (timer) timer.kill(); },
        reset: () => {
           if (timer) timer.kill();
           currentIndex = 0;
           gsap.set($wrapper, { xPercent: 0 });
           gsap.set([$nums, $firstNumClone], { y: 0 });
           gsap.set('.menu-projects-container .fp-mask-inner', { yPercent: 100 });
        }
      };
    }
    menuSlideshow = initMenuProjectSlideshow();

    // Build timeline once and keep it paused/reversed to start
    const menuTl = gsap.timeline({
      paused: true,
      reversed: true,
      onReverseComplete: () => {
        // Clear panel and toggle props so container goes back to standard CSS states
        gsap.set($panel, { clearProps: 'width,height' });
        gsap.set($toggle, { clearProps: 'opacity,visibility' });
        gsap.set($menuContainer, { clearProps: 'width,left,transform' });
      }
    });

    menuTl.to($panel, {
      width: '100%',
      duration: menuAnimationSpeed,
      ease: 'power3.inOut'
    }, 'expandWidth')
      .to($toggle, {
        autoAlpha: 0,
        duration: menuAnimationSpeed,
        ease: 'power3.inOut'
      }, 'expandWidth')
      .to($panel, {
        height: '80svh',
        duration: menuAnimationSpeed,
        ease: 'power3.inOut'
      })
      // .set($panel, { borderRadius: '24px' })
      .set('.menu-panel > .grid-y', { display: 'flex', autoAlpha: 1 })

      // 1. Fade in Close Button
      // .to($closeBtn, {
      //   autoAlpha: 1,
      //   duration: menuAnimationSpeed, // Slightly faster than base duration
      //   ease: 'power3.inOut'
      // }, `-=${menuAnimationSpeed * 0.5}`) // Start sliding in halfway through height expansion
      .set($closeBtn, { visibility: 'visible' })

      // 2. Animate the respective children
      .to('header .menu-projects-container', {
        autoAlpha: 1,
        duration: menuAnimationSpeed,
        ease: 'power3.inOut',
        onComplete: () => { if (menuSlideshow) menuSlideshow.start(); }
      }, `<+${menuAnimationSpeed * 0.5}`) // Starts exactly when height expansion finishes globally
      .to(separatorLines, {
        width: '100%',
        duration: menuAnimationSpeed,
        ease: 'power3.inOut'
      }, `<${menuAnimationSpeed * 0.5}`) // Starts halfway through projectChildren
      .to(menuItems, {
        y: 0,
        duration: menuAnimationSpeed,
        ease: 'power3.inOut',
        stagger: menuAnimationStagger
      }, `<${menuAnimationSpeed * 0.8}`) // Starts when projectChildren is 80% finished
      .to(contactCells, {
        y: 0,
        duration: menuAnimationSpeed,
        ease: 'power3.inOut',
        stagger: menuAnimationStagger * 2,
      }, `-=${menuAnimationSpeed - menuAnimationStagger}`); // Starts exactly 1 stagger step after the last menu item begins

    let isMenuCustomClosing = false;
    let nativePanelWidth = 0;
    let nativePanelHeight = 0;

    function toggleMenu() {
      if (menuTl.reversed()) {
        if (isMenuCustomClosing) return; // Prevent double-clicks while geometrically closing
        
        // Dynamically cache the literal resting geometry mathematically right before any GSAP manipulation expands it!
        nativePanelWidth = $panel.outerWidth();
        nativePanelHeight = $panel.outerHeight();
        
        gsap.set($menuContainer, { width: '100%', left: 0, transform: 'none' });
        if (menuSlideshow) menuSlideshow.reset();
        menuTl.play();
      } else {
        if (isMenuCustomClosing) return;
        isMenuCustomClosing = true;
        if (menuSlideshow) menuSlideshow.stop();
        
        // Build a mathematically customized exit timeline matching the new sequential physics
        const customCloseTl = gsap.timeline({
          onComplete: () => {
            // Unplug the timeline cleanly by hard-snapping the main player to frame 0 flawlessly behind the scenes
            // CRITICAL: We explicitly flip .reversed(true) so the JS state tracker mathematically knows the menu is closed on next click!
            menuTl.pause().progress(0).reversed(true);
            
            // Globally reset CSS matrix tracks back to standard stylesheet parsing, keeping the children's GSAP memory alive!
            gsap.set($panel, { clearProps: 'width,height' });
            gsap.set($toggle, { clearProps: 'opacity,visibility' });
            gsap.set($menuContainer, { clearProps: 'width,left,transform' });
            gsap.set('.menu-panel > .grid-y', { clearProps: 'all' });
            gsap.set($closeBtn, { clearProps: 'all' });
            
            isMenuCustomClosing = false;
          }
        });

        // 1. Securely fade out the active interior layout layers rapidly
        customCloseTl
        // .set($panel, { borderRadius: '16px' })
        .to(['.menu-panel > .grid-y', $closeBtn], { 
          autoAlpha: 0, 
          duration: 0.3,
          ease: 'power2.out'
        })
        // Strip interior grid instantly from the layout tree to eliminate the CSS structural friction that was blocking the initial width-shrink timeline!
        .set('.menu-panel > .grid-y', { display: 'none' })
        // 2. Shrink vertical height perfectly reflecting identical inverse GSAP opening speed
        .to($panel, {
          height: nativePanelHeight, // Inject dynamically clean cached tracking variable!
          duration: menuAnimationSpeed,
          ease: 'power3.inOut'
        })
        // 3. Shrink horizontal width last, collapsing structurally inwards towards the toggle node
        .to($panel, {
          width: nativePanelWidth, // Inject dynamically clean cached tracking variable!
          duration: menuAnimationSpeed,
          ease: 'power3.inOut'
        }, 'shrinkW')
        // Crossfade the toggle token gently synced entirely to width geometry 
        .to($toggle, {
          autoAlpha: 1,
          duration: menuAnimationSpeed,
          ease: 'power3.inOut'
        }, 'shrinkW');
      }
    }

    $toggle.on('click', function (e) {
      e.preventDefault();
      toggleMenu();
    });

    $closeBtn.on('click', function (e) {
      e.preventDefault();
      toggleMenu();
    });

    $(document).on('click', function (e) {
      if (menuTl.reversed()) return;

      const $target = $(e.target);
      // Close only if click is outside of the panel and toggle button
      if ($target.closest('.menu-panel').length === 0 && $target.closest('.menu-toggle').length === 0) {
        toggleMenu();
      }
    });

    // --- Unified Global Header Visibility Physics ---
    if (typeof ScrollTrigger !== 'undefined') {
      let menuLocks = 0;
      let headerLocks = 0;

      const evaluateNavVisibility = () => {
        if (menuLocks > 0) {
          gsap.to('.menu-panel', { opacity: 0, duration: 0.5, overwrite: 'auto', onComplete: () => $('.menu-panel').css('pointer-events', 'none') });
        } else {
          $('.menu-panel').css('pointer-events', 'auto');
          gsap.to('.menu-panel', { opacity: 1, duration: 0.5, overwrite: 'auto', onComplete: () => { void $('.menu-panel').get(0).offsetHeight; } });
        }

        if (headerLocks > 0) {
          gsap.to('.menu-logo-container', { opacity: 0, duration: 0.5, overwrite: 'auto', onComplete: () => $('.menu-logo-container').css('display', 'none') });
        } else {
          $('.menu-logo-container').css('display', '');
          gsap.to('.menu-logo-container', { opacity: 1, duration: 0.5, overwrite: 'auto' });
        }
      };

      // 1. Footer Lock (Hides universally)
      ScrollTrigger.create({
        trigger: 'main',
        start: 'bottom bottom',
        end: '+=99999',
        refreshPriority: -10,
        onToggle: (self) => {
          if (self.isActive) { menuLocks++; headerLocks++; } 
          else { menuLocks--; headerLocks--; }
          evaluateNavVisibility();
        }
      });

      // 2. Section Characteristic Locks (Hides based on custom attributes)
      $('section[data-hide-menu], section[data-hide-header]').each(function() {
        const hidesMenu = this.hasAttribute('data-hide-menu');
        const hidesHeader = this.hasAttribute('data-hide-header');
        
        ScrollTrigger.create({
          trigger: this,
          start: 'top 15%', // Evaluates true exactly when the section clears the top quarter of screen
          end: 'bottom 15%', 
          onToggle: (self) => {
            if (self.isActive) {
              if (hidesMenu) menuLocks++;
              if (hidesHeader) headerLocks++;
            } else {
              if (hidesMenu) menuLocks--;
              if (hidesHeader) headerLocks--;
            }
            evaluateNavVisibility();
          }
        });
      });
    }

    /* Menu item hover effect */
    const $menuItems = $('.menu .menu-item');
    if (isDesktop) {
      var menuItemHeight = 0;
      $menuItems.each(function() {
        const $item = $(this);
        const $link = $item.find('a');
        const text = $link.html(); // assume only one plain-text child
        const $wrapped = $('<div>'+text+'</div>');
        $link.html('');
        $wrapped.appendTo($link).clone().appendTo($link);
        $item.height($item.find('a div').eq(0).outerHeight());
        menuItemHeight = Math.max(menuItemHeight, $item.outerHeight());
      })
      $menuItems.height(menuItemHeight);
    }

  });
})(jQuery);
